// extracted by mini-css-extract-plugin
module.exports = {"heading":"_3LhkAakhA9J4EXoVaryA83","link":"Pv52PNhJHs3k9ZR0q8mRg","generator":"_1ymXnKnqqzwxatGKIdNfEq","generatorCollapsed":"_9i08-NdPRgkiat_1Gb3DD"};